// ===================================================================
// src/app/pages/BuildDesatualizado.tsx
//
// Exibida quando um chunk lazy falha ao carregar (deploy novo enquanto a
// aba antiga continua aberta). O caminho de saída é sempre recarregar.
// ===================================================================

import { RefreshCw, Home } from 'lucide-react';
import { Button } from '../components/ui/button';
import { OwlStatePage } from '../components/common/OwlStatePage';

export default function BuildDesatualizado() {
  const reload = () => window.location.reload();

  return (
    <OwlStatePage
      eyebrow="Nova versão disponível"
      title="A Sophia foi atualizada"
      description={
        <>
          Esta aba estava a usar uma versão anterior da aplicação e alguns
          ficheiros já não existem no servidor. Recarregue a página para
          continuar na versão mais recente — nada do seu trabalho guardado
          foi perdido.
        </>
      }
      actions={
        <>
          <Button onClick={reload} className="gap-2">
            <RefreshCw className="size-4" />
            Recarregar agora
          </Button>
          <Button
            variant="outline"
            onClick={() => { window.location.href = '/'; }}
            className="gap-2"
          >
            <Home className="size-4" />
            Ir para o início
          </Button>
        </>
      }
      footer="Se a mensagem se repetir, limpe a cache do navegador (Ctrl/⌘ + Shift + R)."
    />
  );
}
